@if (loading()) {
  <p-message severity="info"
             class="photo-message"
             [class.has-photos]="images().length > 0"
             [attr.data-testid]="testId() + '-loading'">
    Adding {{ processingCount() }} images...
  </p-message>
}

@if (showPager()) {
  <p-tabs [value]="activePage()"
          (valueChange)="onPageChange($event)"
          [scrollable]="true"
          class="photo-pager"
          [attr.data-testid]="testId() + '-pager'">
    <p-tablist>
      @for (page of pages(); track page.index) {
        <p-tab [value]="page.index"
               [attr.data-testid]="testId() + '-pager-tab-' + page.index">
          {{ page.label }}
        </p-tab>
      }
    </p-tablist>
  </p-tabs>
}

<div role="group"
     class="photo-grid"
     [attr.data-testid]="testId() + '-grid'">
  @for (image of pagedImages(); track image.index) {
    <button class="photo-cell"
            type="button"
            (click)="imageClicked.emit(image.index)"
            [attr.data-testid]="testId() + '-thumbnail-' + image.index">
      <img [src]="image.src"
           [alt]="'View photo ' + (image.index + 1)"
           loading="lazy"
           decoding="async" />
    </button>
  }

  @for (skeleton of skeletons(); track skeleton) {
    <div class="photo-cell photo-cell-skeleton"
         aria-hidden="true"
         [attr.data-testid]="testId() + '-skeleton-' + skeleton"></div>
  }
</div>

@if (optimizing()) {
  <p-message severity="info"
             class="photo-message has-photos"
             [attr.data-testid]="testId() + '-optimizing'">
    Optimizing {{ processingCount() }} images...
  </p-message>
}

<div class="photos-buttons-container"
     [class.input-invalid]="invalid()"
     [attr.data-testid]="testId() + '-actions'">
  @if (!hideCaptureButtons()) {
    <button type="button"
            class="add-photo"
            [disabled]="disabled() || atMaxImages()"
            [attr.aria-disabled]="disabled() || atMaxImages()"
            (click)="triggerCamera()"
            [attr.aria-controls]="inputId() + '-camera-input'"
            [attr.data-testid]="testId() + '-btn-camera'">
      <img src="assets/icons/cameraAdd.svg"
           alt=""
           aria-hidden="true" />
      <p>{{ cameraLabel() }}</p>
    </button>

    <button type="button"
            class="add-photo"
            [disabled]="disabled() || atMaxImages()"
            [attr.aria-disabled]="disabled() || atMaxImages()"
            (click)="triggerGallery()"
            [attr.aria-controls]="inputId() + '-gallery-input'"
            [attr.data-testid]="testId() + '-btn-library'">
      <img src="assets/icons/photoLibrary.svg"
           alt=""
           aria-hidden="true" />
      <p>{{ libraryLabel() }}</p>
    </button>
  }

  <input #cameraInput
         type="file"
         accept="image/*"
         capture="environment"
         [attr.id]="inputId() + '-camera-input'"
         style="display: none"
         (change)="handleFiles($event)"
         [attr.data-testid]="testId() + '-input-camera-file'" />

  <input #galleryInput
         multiple
         type="file"
         accept="image/*"
         [attr.id]="inputId() + '-gallery-input'"
         style="display: none"
         (change)="handleFiles($event)"
         [attr.data-testid]="testId() + '-input-gallery-file'" />
</div>
